// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__20GMv","large":"styles_large__2i-IZ"};